import useSrm from '@/shared/data/useSrm';

export enum SrmTeam {
  US_MKT = 'USA-MKT',
  US_KS = 'US-KS-HQ',
  US_VA = 'US-VA-SUTHERLAND',
  AU_SYDNEY = 'AU-SYDNEY',
  AUS_MKT = 'AUS-MKT',
  ESRM = 'ESRM',
  IN_NOIDA = 'IN-NOIDA',
  IN_MUMBAI = 'IN-MUMBAI',
  IND_MKT = 'IND-MKT',
  UK_BRISTOL = 'UK-BRISTOL',
  UK_IBEX = 'UK-IBEX',
  GBR_MKT = 'GBR-MKT',
  CN_SUZHOU = 'CN-SUZHOU',
  CHN_MKT = 'CHN-MKT',
}

export enum UserRegion {
  AMER = 'AMER', // North, Central and South America
  EMEA = 'EMEA', // Europe, the Middle East, and Africa
  APAC = 'APAC', // Asia Pacific
  INDIA = 'INDIA', // India
  UNKNOWN = 'UNKNOWN', // We couldn't derive a region from the SRM Team
}

const AMER_TEAMS = [SrmTeam.US_KS, SrmTeam.US_VA, SrmTeam.US_MKT, SrmTeam.ESRM];

const EMEA_TEAMS = [SrmTeam.UK_BRISTOL, SrmTeam.UK_IBEX, SrmTeam.GBR_MKT];

const APAC_TEAMS = [SrmTeam.AU_SYDNEY, SrmTeam.AUS_MKT, SrmTeam.CN_SUZHOU, SrmTeam.CHN_MKT];

const INDIA_TEAMS = [SrmTeam.IN_NOIDA, SrmTeam.IN_MUMBAI, SrmTeam.IND_MKT];

const useRegionBySrm = () => {
  const { team } = useSrm();

  if (!team) {
    return UserRegion.UNKNOWN;
  }

  if (AMER_TEAMS.includes(team as SrmTeam)) {
    return UserRegion.AMER;
  } else if (EMEA_TEAMS.includes(team as SrmTeam)) {
    return UserRegion.EMEA;
  } else if (APAC_TEAMS.includes(team as SrmTeam)) {
    return UserRegion.APAC;
  } else if (INDIA_TEAMS.includes(team as SrmTeam)) {
    return UserRegion.INDIA;
  } else {
    return UserRegion.UNKNOWN;
  }
};

export default useRegionBySrm;
